/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getNextQuoteSerial = /* GraphQL */ `
  mutation GetNextQuoteSerial {
    getNextQuoteSerial
  }
`;
export const setUserGroup = /* GraphQL */ `
  mutation SetUserGroup($username: String!, $group: String!, $member: Boolean!) {
    setUserGroup(username: $username, group: $group, member: $member)
  }
`;
export const createQuote = /* GraphQL */ `
  mutation CreateQuote(
    $input: CreateQuoteInput!
    $condition: ModelQuoteConditionInput
  ) {
    createQuote(input: $input, condition: $condition) {
      id
      userId
      quoteId
      description
      config
      metrics
      bom
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const updateQuote = /* GraphQL */ `
  mutation UpdateQuote(
    $input: UpdateQuoteInput!
    $condition: ModelQuoteConditionInput
  ) {
    updateQuote(input: $input, condition: $condition) {
      id
      userId
      quoteId
      description
      config
      metrics
      bom
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const deleteQuote = /* GraphQL */ `
  mutation DeleteQuote(
    $input: DeleteQuoteInput!
    $condition: ModelQuoteConditionInput
  ) {
    deleteQuote(input: $input, condition: $condition) {
      id
      userId
      quoteId
      description
      config
      metrics
      bom
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const createQuoteCounter = /* GraphQL */ `
  mutation CreateQuoteCounter(
    $input: CreateQuoteCounterInput!
    $condition: ModelQuoteCounterConditionInput
  ) {
    createQuoteCounter(input: $input, condition: $condition) {
      id
      currentValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuoteCounter = /* GraphQL */ `
  mutation UpdateQuoteCounter(
    $input: UpdateQuoteCounterInput!
    $condition: ModelQuoteCounterConditionInput
  ) {
    updateQuoteCounter(input: $input, condition: $condition) {
      id
      currentValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuoteCounter = /* GraphQL */ `
  mutation DeleteQuoteCounter(
    $input: DeleteQuoteCounterInput!
    $condition: ModelQuoteCounterConditionInput
  ) {
    deleteQuoteCounter(input: $input, condition: $condition) {
      id
      currentValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAuditEvent = /* GraphQL */ `
  mutation CreateAuditEvent($input: CreateAuditEventInput!) {
    createAuditEvent(input: $input) {
      id
      eventType
      artifactType
      quoteSerial
      vendor
      payload
      owner
      createdAt
    }
  }
`;
